import {
    temAcesso
} from '@/shared/auth/temAcesso'

const DadosCadastraisDetalhar = () => import('./DadosCadastraisDetalhar.vue')
const DadosCadastraisForm = () => import('./DadosCadastraisForm.vue')

export default {
    path: 'dadoscadastrais',
    name: 'FornecedorDadosCadastrais',
    component: DadosCadastraisDetalhar,
    beforeEnter: (to, from, next) => {
        if (temAcesso('FORN-DADOS-00')) {
            next()
        }
    },
    children: [{
        path: 'atualizar',
        name: 'FornecedorDadosCadastrais_Atualizar',
        component: DadosCadastraisForm,
        beforeEnter: (to, from, next) => {
            if (temAcesso('FORN-DADOS-01')) {
                next()
            }
        }
    }]
}
